import { combineReducers } from 'redux';

import feedback from './feedbackReducer';
import measurement from './measurementsReducer';
import user from './usersReducer';
import numbers from './numbersReducer';
import workout from './workoutReducer';
import login from './loginReducer';

const rootReducer = combineReducers({
    login,
    feedback,
    measurement,
    user,
    numbers,
    workout,
});

export default rootReducer;